export const StatCard = ({ label, value, icon: Icon, accent = "text-slate-900", testId, hint }) => (
  <div data-testid={testId} className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 transition-shadow hover:shadow-[0_8px_30px_rgba(15,23,42,0.06)] fade-up">
    <div className="flex items-center justify-between">
      <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</span>
      {Icon && <Icon className={`h-4 w-4 ${accent}`} />}
    </div>
    <div className={`mt-3 font-mono text-3xl font-semibold tracking-tight ${accent}`} data-testid={testId ? `${testId}-value` : undefined}>
      {Number(value || 0).toLocaleString("id-ID")}
    </div>
    {hint && <p className="mt-1 text-xs text-slate-500">{hint}</p>}
  </div>
);
